import { Anchor } from "./anchor"
import { Badge } from "./badge"
import { Button } from "./button"
import { RichTextEditor } from "./editor"
import { Loader } from "./loader"
import { Paper } from "./paper"
import { Table } from "./table"

export const components = {
  Anchor,
  Button,
  Badge,
  Table,
  Loader,
  Paper,
  RichTextEditor,
}
